import React, { type ReactElement } from "react";

const Card = ({
  title,
  children,
  className,
}: {
  title?: string;
  children: React.ReactElement | ReactElement[];
  className?: string;
}) => {
  return (
    <div
      className={"card bg-base-200 text-neutral-primary " + (className ?? "")}
    >
      <div className="card-body flex flex-col gap-4">
        {title && <h2 className="card-title mb-2">{title}</h2>}

        {children}
      </div>
    </div>
  );
};

const SubCard = ({
  title,
  children,
  className,
}: {
  title?: string;
  children: React.ReactElement | ReactElement[];
  className?: string;
}) => {
  return (
    <div
      className={"card bg-base-100 text-neutral-primary " + (className ?? "")}
    >
      <div className="card-body flex flex-col gap-4">
        {title && <h3 className="card-title">{title}</h3>}
        {children}
      </div>
    </div>
  );
};

export { Card, SubCard };
